import { Tooltip } from "@mui/material";

// One person with a login that reaches the customer, as the customers list
// sends them.
export type CustomerUser = {
  id: string;
  name: string;
  email: string;
  role: string;
  active: boolean;
};

// Who can log in for a customer. The names are the answer at a glance and the
// addresses are one hover away, since the office usually wants to write to one
// of them.
//
// A login that exists but is switched off is still listed and marked: a
// customer whose only logins are like that is not one with people who can pay,
// and hiding them would make the two look the same.
const CustomerUsersCell = ({ users }: { users?: CustomerUser[] }) => {
  if (!users || users.length === 0) return <>—</>;

  const label = (user: CustomerUser) =>
    `${user.name || user.email}${user.active ? "" : " (inactive)"}`;

  return (
    <Tooltip
      arrow
      title={users
        .map((user) => `${user.name || user.email} — ${user.email}${user.active ? "" : " (inactive)"}`)
        .join("; ")}
    >
      <span>{users.map(label).join(", ")}</span>
    </Tooltip>
  );
};

export default CustomerUsersCell;
